module.exports = function (obj, proposal) {
  var proposal_idx = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var faction = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  var help = "".concat(obj.mod.returnFactionName(faction), " - ").concat(obj.mod.returnFactionName(proposal.proposer), " offers the following pact:");
  var terms = obj.mod.convertTermsToText(proposal.terms);
  var proposal_html = '<ul>';
  for (var i = 0; i < terms.length; i++) {
    proposal_html += "<li>".concat(terms[i], "</li>");
  }
  proposal_html += '</ul>';
  var html = "\n\t  <div class=\"diplomacy-confirm-overlay\">\n\t    <div class=\"help\">".concat(help, "</div>\n\t    <div class=\"content\">").concat(proposal_html, "</div>\n\t    <div class=\"buttons\">\n\t      <div class=\"accept\" id=\"accept\">accept</div>\n\t      <div class=\"reject\" id=\"reject\">reject</div>\n\t    </div>\n\t  </div>\n\t");
  return html;
};